module.exports = __webpack_public_path__ + "img/5.a1bf86e3.png";